import { FC, ReactNode } from 'react';
import { css } from '@emotion/react';
import { spacing, colors } from '../../../../styles';

interface DataCardProps {
  children: ReactNode;
  accentColor?: string;
  padding?: string;
}

export const DataCard: FC<DataCardProps> = ({ children, accentColor, padding = spacing.deci }) => (
  <div
    css={css`
      background: ${colors.fog};
      border-radius: 6px;
      padding: ${padding};
      ${accentColor ? `border-left: 3px solid ${accentColor};` : ''}

      html[data-theme='dark'] & {
        background: rgba(255, 255, 255, 0.03);
      }
    `}
  >
    {children}
  </div>
);
